import { useSuspenseQuery } from '@apollo/client';
import React from 'react';
import { Stack } from '../../../components/Stack/Stack';
import { t } from '../../../locales/translate';
import { withSuspendedCard } from '../../../util/suspense';
import { graphql } from '../../../generated';
import { useParams } from 'react-router-dom';
import { Card } from '../../../components/Card/Card';
import { Icon } from '../../../components/Icon/Icon';
import { KeyValueTable } from '../../../components/KeyValueTable/KeyValueTable';
import { formatCurrency, formatPercentage } from '../../../util/formatters';
import { useModalPresenter } from '../../../components/Modal/PresentedModal';
import { VoucherCampaignUpdate } from './update';

const VOUCHER_CAMPAIGN_DETAILS = graphql(`
  query VoucherCampaignDetails($id: ID!) {
    voucherCampaign(id: $id) {
      id
      discountType
      amount
      usage
      target
      costSplit
      shop {
        id
        name
      }
    }
  }
`);

function CampaignDetails$(): JSX.Element {
  const { id } = useParams<{ id: string }>();

  const { data } = useSuspenseQuery(VOUCHER_CAMPAIGN_DETAILS, { variables: { id } });

  const { shop, usage, discountType, amount, costSplit } = data.voucherCampaign;

  const modal = useModalPresenter();

  const keyValueTableItems = [
    {
      key: t.page.voucherCampaign.shop,
      value: shop.name,
    },
    {
      key: t.page.voucherCampaign.voucherTypeAndRate.title,
      value: discountType === 'ABSOLUTE' ? formatCurrency(amount) : formatPercentage(amount),
    },
    {
      key: t.page.voucherCampaign.codeUsage,
      value: t.page.voucherCampaign.voucherTypeAndRate.use[usage.toLowerCase()],
    },
    { key: t.page.voucherCampaign.contractDiscountShare, value: formatPercentage(costSplit) },
  ];

  return (
    <Stack size="lg">
      <Card
        title={t.page.voucherCampaign.campaignDetails}
        actions={<Icon name="edit" onClick={() => modal.present(VoucherCampaignUpdate, { id })} />}
      >
        <KeyValueTable items={keyValueTableItems} gap="16" />
      </Card>
    </Stack>
  );
}

export const CampaignDetails = withSuspendedCard(CampaignDetails$, {
  loadingTitle: t.page.voucherCampaigns.voucherCampaigns,
});
